import { useEffect, useState } from 'react';
import { Friendship } from '@/api';

import { jwtDecode } from 'jwt-decode';
import createT from 'T';
const T = createT();
T({
  'already added as a friend': 'Déjà ajouté·e comme ami·e',
  'record not found': 'Token invalide',
});
const AcceptFriendship = () => {
  const [token, setToken] = useState('');
  const [tokenClass, setTokenClass] = useState('bg-none');
  const [error, setError] = useState(false);

  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [exp, setExp] = useState(null);
  const [remains, setRemains] = useState(0);

  const [response, setResponse] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setError(false);
    setErrors({});
    setResponse('');
    if (token) {
      try {
        const { exp, message, name } = jwtDecode(token);
        setMessage(message);
        setName(name);
        setExp(exp);
      } catch {
        setError(true);
        setMessage('');
        setName('');
        setExp(null);
      }
    } else {
      setMessage('');
      setName('');
      setExp(null);
    }
  }, [token]);

  useEffect(() => {
    if (!token) {
      setTokenClass('bg-none');
    } else if (error) {
      setTokenClass('bg-error');
    } else {
      setTokenClass('bg-success');
    }
  }, [token, error]);

  useEffect(() => {
    const updateExpiration = () => {
      if (exp !== null) {
        const remains = Math.ceil((exp - new Date().getTime() / 1000) / 60);
        if (remains <= 0) {
          setError(true);
        }
        setRemains(remains);
      }
    };
    updateExpiration();
    const timer = setInterval(updateExpiration, 10000);
    return () => clearInterval(timer);
  }, [exp]);

  const acceptFriendshipRequest = async () => {
    const friendship = new Friendship({ token });
    setToken('');
    try {
      const success = await friendship.save();
      setErrors(friendship.errors);
      if (success) {
        setResponse('Accepté');
      } else {
        setResponse(friendship.errors.friendId?.message || 'Refusé');
      }
    } catch (e) {
      setErrors({ network: e });
      setResponse(e.message || 'Erreur serveur');
    }
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0) {
      const timer = setTimeout(() => setResponse(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [response, errors]);

  return (
    <div>
      <label className='input'>
        Token
        <input
          type='text'
          className={`grow ${tokenClass}`}
          placeholder='Token'
          value={token}
          onChange={({ target }) => setToken(target.value)}
        />
      </label>

      {name &&
        (message ? (
          <div>{`${name} vous dit “${message}”`}</div>
        ) : (
          <div>Demande d'amitié de {name}</div>
        ))}
      {response && (
        <div
          className={`w-full alert ${Object.keys(errors).length > 0 ? 'alert-error' : 'alert-success'}`}
        >
          {T(response)}
        </div>
      )}
      <div className='flex flex-row justify-around w-full'>
        <button
          className='btn btn-primary'
          disabled={!name || error || !token || remains <= 0}
          onClick={acceptFriendshipRequest}
        >
          Accepter{' '}
          {token && name && (remains > 0 ? `(${remains} minutes)` : '(expiré)')}
        </button>
        <button
          className='btn'
          disabled={!name || error || !token || remains <= 0}
          onClick={() => setToken('')}
        >
          Refuser
        </button>
      </div>
    </div>
  );
};

export default AcceptFriendship;
